<template>
  <div class="body">
    <el-container>
      <!-- <ReportsAside /> -->
      <el-main>
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="3" :lg="3" :md="6" :sm="12">
              <div class="searchForm">
                <label for="code"></label>
                <el-input
                  @change="selectSearchCode"
                  placeholder="بحث بالفاتورة "
                  autofocus
                  type="text"
                  @focus="$event.target.select()"
                  v-model="searchCode"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="10" :lg="10" :md="6" :sm="12">
              <SearchSuppliers
                :searchOnly="true"
                :supplier="supplier"
                @selectedSupplier="selectedSupplier"
                :productsLength="productsLength"
                :productSearch="false"
              />
            </el-col>
            <el-col :xl="10" :lg="10" :md="6" :sm="12">
              <div class="block">
                <!-- <span class="demonstration">Default</span> -->
                <el-date-picker
                  @change="selectDateRange"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :xl="1" :lg="1" :sm="12">
              <el-button
                type="success"
                title="طباعه"
                icon="el-icon-printer"
                @click="sendToPrintAll(tableData)"
              ></el-button>
            </el-col>
          </el-row>
          <customer-info
            :customer="supplier"
            :type="'supplier'"
            v-if="supplier != null"
          />
        </div>
        <el-table
          class="mt-2"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="overflow: auto; width: 100%"
          v-infinite-scroll="loadMoreData"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column sortable width="100" label="الفاتورة" prop="id">
          </el-table-column>
          <el-table-column label="القيمة" prop="total_cost"> </el-table-column>
          <el-table-column label="الخصم" prop="discount"> </el-table-column>
          <el-table-column label="الاجمالي" prop="total"> </el-table-column>
          <el-table-column width="150" label="المورد" prop="supplier.name">
          </el-table-column>
          <el-table-column width="100" label="بواسطة" prop="user.name">
          </el-table-column>
          <el-table-column
            width="160"
            sortable
            label="التوقيت"
            prop="created_at"
          >
          </el-table-column>
          <el-table-column width="100" label="المسح" prop="deleted_by">
          </el-table-column>
          <el-table-column
            width="160"
            sortable
            label="توقيت المسح"
            prop="updated_at"
          >
          </el-table-column>
          <el-table-column label="اجراءات" width="120">
            <template slot-scope="scope">
              <el-row :gutter="10">
                <el-col :lg="12">
                  <el-button
                    type="success"
                    size="mini"
                    title="طباعه"
                    icon="el-icon-printer"
                    @click="sendToPrint(scope.row)"
                  ></el-button>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ReportsAside from "@/components/ReportsAside.vue";
import SearchSuppliers from "@/components/Suppliers/Search";
import CustomerInfo from "../../components/CustomerInfo.vue";
// import { ipcRenderer } from "electron";

export default {
  name: "Products",

  components: {  SearchSuppliers, CustomerInfo },

  data() {
    return {
      true: true,
      productsLength: 0,
      supplier: null,
      dateRange: null,
      editFormVisible: false,
      tableData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      current_page: 1,
      page_limit: 1,
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      filterMode: false,
    };
  },
  created() {
    this.getDeletedPurchases();
  },
  methods: {
    sendToPrint(row) {
      console.log("row", row);
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   type: "saleInvoice",
      //   title: " شراء المحذوفه ",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    sendToPrintAll(row) {
      console.log("🚀 ~ sendToPrintAll ~ row:", row)
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   type: "allReports",
      //   title: " مشتريات المحذوفه ",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    selectedSupplier(e) {
      this.supplier = e.supplier;
      this.filterMode = true;
      this.getDeletedPurchases();
    },
    selectSearchCode() {
      this.filterMode = true;
      this.getDeletedPurchases();
    },
    selectDateRange() {
      this.filterMode = true;
      this.getDeletedPurchases();
    },
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getSales();
      }
    },
    getDeletedPurchases() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.filterMode) {
        this.pagination.current_page = 1;
        this.tableData = [];
      }
      let url = `deleted-purchases/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?page=${this.pagination.current_page}`;
      if (this.dateRange != null) {
        url += "&start_date=" + this.dateRange[0];
        url += "&end_date=" + this.dateRange[1];
      }
      if (this.searchCode.trim() != "") {
        url += "&code=" + this.searchCode;
      }
      if (this.supplier != null) {
        url += "&supplier=" + this.supplier.id;
      }

      axiosApi
        .get(url)
        .then((res) => {
          res.data.data.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;

          this.tableData.map((invoice) => {
            invoice.total = invoice.total_cost - invoice.discount;
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
          this.filterMode = false;
        });
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 88.5%;
  overflow-y: scroll;
}
</style>
